import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [0,3];

export const dictionary = {
		"/": [8],
		"/Ecc/[ipn]": [~9,[],[2]],
		"/IssuerMock/Issuer": [10],
		"/LearnMore": [~11,[3],[4]],
		"/LearnMore/v1.0": [~13,[3],[4]],
		"/LearnMore/v1.1": [~14,[3],[4]],
		"/LearnMore/v1.99": [~15,[3],[4]],
		"/LearnMore/v5.0": [~16,[3],[4]],
		"/LearnMore/[version]": [~12,[3],[4]],
		"/LoanAgreement/[ipn]": [~17],
		"/PrivacyPolicy": [~18,[],[5]],
		"/Receipt/[ipn]": [~19],
		"/Reports": [~20],
		"/TermsAndConditions": [~21,[],[6]],
		"/TermsAndConditions/[ipn]": [~22,[],[6]],
		"/Tila/[ipn]": [~23,[],[7]],
		"/fee-calculator": [~25],
		"/[error=error]": [~24]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';